import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get, patch } from 'api/requests';

import { AppThunk } from 'store/types';
import {
  ApartmentsSettingStore,
  ApartmentsSetting,
} from 'features/Setting/ApartmentsSetting/types';

const initialState: ApartmentsSettingStore = {
  list: [],
  loading: false,
};

const loading: CaseReducer<ApartmentsSettingStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const reset: CaseReducer<ApartmentsSettingStore> = () => initialState;

const list: CaseReducer<ApartmentsSettingStore, PayloadAction<ApartmentsSetting[]>> = (
  state,
  action,
) => {
  state.list = action.payload;
};

export const apartmentsSettingsSlice = createSlice({
  name: 'apartmentsSettings',
  initialState,
  reducers: {
    reset,
    loading,
    list,
  },
});

const {
  reset: setReset,
  loading: setLoading,
  list: setCurrentSettings,
} = apartmentsSettingsSlice.actions;

const setSettings =
  (settings: ApartmentsSetting[]): AppThunk =>
  dispatch => {
    dispatch(setCurrentSettings(settings));
  };

export const getSettings = (): AppThunk => dispatch => {
  get<ApartmentsSetting[]>('/api/timesheet/limit/').then(({ data }) => {
    dispatch(setSettings(data));
  });
};

export const patchSettings =
  (project: number, setting: ApartmentsSetting, callback?: () => void): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    patch(`/api/timesheet/limit/${project}/`, setting)
      .then(() => {
        dispatch(getSettings());
      })
      .finally(() => {
        dispatch(setLoading(false));
        callback && callback();
      });
  };

export { setReset };
